import { render, staticRenderFns } from "./DqKanban.vue?vue&type=template&id=e5fa9d78&"
import script from "./DqKanban.vue?vue&type=script&lang=js&"
export * from "./DqKanban.vue?vue&type=script&lang=js&"
import style0 from "./DqKanban.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports